import { createContext, useContext, ReactNode } from "react";

interface KPIListContextValue {
  kpiListData: HatvKpiApiResponse;
  isLoadingKPIList: boolean;
  isFetchingKPIList: boolean;
  isKPIListError: boolean;
  isKPIListSuccess: boolean;
  refetchKPIList: () => void;
}

interface KPIListProviderProps {
  value: KPIListContextValue;
  children: ReactNode;
}

const KPIListContext = createContext<KPIListContextValue | null>(null);

export const KPIListProvider = ({ value, children }: KPIListProviderProps) => (
  <KPIListContext.Provider value={value}>{children}</KPIListContext.Provider>
);

export const useKPIList = (): KPIListContextValue => {
  const context = useContext(KPIListContext);
  if (!context) {
    throw new Error("useKPIList must be used within KPIListProvider");
  }
  return context;
};
